import { createMemo } from "solid-js";
import { type AdminCapability, roleCan } from "@famidex/shared";
import { useSession } from "@/lib/auth";

/**
 * Reactive view of the current admin's role + capability checks. Mirrors the
 * backend capability map (`@famidex/shared` `capabilities`) so the back-office UI
 * never offers an action that would 403. The backend stays the source of truth.
 */
/**
 * Espejo en la UI de `Capability::ManageContent`: ¿puede este rol MUTAR el
 * contenido del back-office (fuentes, temas, plantillas y campañas de email)?
 *
 * El servidor lo aplica en `manage_content_middleware` (lecturas `get` pasan,
 * mutaciones `post` exigen la capacidad). La regla de la casa es no ofrecer
 * jamás una acción que el backend va a rechazar: sin este gate, `read_only`
 * seguiría viendo botones que ahora responden 403 sin explicación.
 */
export function useCanWriteContent() {
  const { can } = useAdminCapabilities();
  return () => can("content.write");
}

export function useAdminCapabilities() {
  const session = useSession();
  const role = createMemo(() => session.data?.user.role);
  const can = (capability: AdminCapability) => roleCan(role(), capability);
  return { role, can };
}
